<template>
  <el-dialog title="" :visible.sync="visible" :before-close="handleClose"  width="80%">
    <el-table
      :data="tableData"
      border
      :header-cell-style="{background:'#66b1ff',color:'#fff'}"
      style="width: 100%">
      <el-table-column prop="prop" label="字段" align="center" ></el-table-column>
      <el-table-column prop="label" label="名称" align="center">
        <template #default="scope">
          <el-input  v-model="scope.row.label" readonly>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="columnShow" label="是否隐藏" align="center">
        <template #default="scope">
          <el-select v-model="scope.row.columnShow" placeholder="请选择">
            <el-option label="显示" value="显示">显示</el-option>
            <el-option label="隐藏" value="隐藏">隐藏</el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" style="width: 100%;display: inline-block;text-align: center">
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/index'
import { http } from '@/utils/axios'
export default {
  name: 'CoursewareManagerColumn',
  data () {
    return {
      isWorking:'2',
      visible: false,
      tableData: [
      {prop:'id',label:'id',columnShow:'显示'},
      {prop:'uname',label:'创建人',columnShow:'显示'},
      {prop:'title',label:'名称',columnShow:'显示'},
      {prop:'teacherName',label:'讲师',columnShow:'显示'},
      {prop:'typeName',label:'类别',columnShow:'显示'},
      {prop:'professionName',label:'引用量',columnShow:'显示'},
      {prop:'type',label:'类型',columnShow:'显示'},
      {prop:'ctime',label:'创建时间',columnShow:'显示'},
      {prop:'updateTime',label:'更新时间',columnShow:'显示'}
      ],

    }
  },
  methods: {
    // 初始化
    init (row, status, loginUid) {
      this.visible = true
      this.loginUid = loginUid
    },

    // 获取用户简表文件
    getUserFile (idCard) {

    },

    // 处理弹窗关闭事件
    handleClose (msg) {
      this.visible = false
      this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm () {
      console.log(this.tableData);
      this.visible = false
      this.$emit('showColumn', this.tableData)
      parent.location.reload()
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  @include flex(center, flex-start);
  .info{
    width: 50%;
    border-right: 1px solid  #4e5359;
    &:nth-last-child(1){
      border-right: none;
    }
    .info-title{
      @include font(18px,  #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form{
    .el-form-item{
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>

</style>
